import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UpsellService } from '@app/shared/+state/shared/upsell.service';
import { UsersFacade } from '@app/shared/+state/users';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sbnb-demo-my-business',
  templateUrl: './demo-my-business.component.html',
  styleUrls: ['./demo-my-business.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoMyBusinessComponent implements OnInit {
  public isTrial$ = this.usersFacade.user$.pipe(map((user) => !user.is_subscribed));

  constructor(
    private upsellService: UpsellService,
    private usersFacade: UsersFacade
  ) {}

  ngOnInit(): void {}

  public contactSales(): void {
    this.upsellService.contactSalesForMogul('YourPlanPage');
  }

  public redirectToPlans(): void {
    this.upsellService.redirectToPlans();
  }
}
